import moment from 'moment';

export const notFalsy = (value: any) => {
  return value !== undefined && value !== null
}

export const isDomElement = (o: any) => {
  return (
    typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
    o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
  );
}

export const scrollToElement = (selector: any, align = "start") => {
  let alignmentHeight;
  switch (align) {
    case "center":
      alignmentHeight = window.innerHeight / 2;
      break;
    case "end":
      alignmentHeight = window.innerHeight - window.innerHeight / 5;
      break;
    case "start":
    default:
      alignmentHeight = 0;
  }

  let element = isDomElement(selector)
    ? selector
    : document.querySelector(selector);

  if (element) {
    let labelOffset = 0;
    if (element.tagName.toUpperCase() === "INPUT") {
      const label = document.querySelector(".c-form-field__label");
      labelOffset = (label && label.getBoundingClientRect().height) || 0;
    }
    // get relative element position from top for scrolling
    const position = element.getBoundingClientRect().top;
    if (/Edge/.test(navigator.userAgent)) {
      window.scrollTo(
        0,
        element.getBoundingClientRect().top + window.scrollY - labelOffset - 120
      );
    } else {
      window.scrollBy({
        top: position - alignmentHeight - labelOffset,
        left: 0,
        behavior: "smooth",
      });
    }
  }
};

export const alphabeticallyValueCompare = (a: any, b: any) => {
  if (a.value < b.value) {
    return -1;
  } else if ( a.value > b.value ){
    return 1;
  }
  return 0;
}

export const monthsDifference = (startDate, endDate) => Math.abs(moment(endDate).diff(moment(startDate), 'months'));

export const openTabUrl = (url: string) => {
  window.open(url, '_blank')
}
